import React from 'react'
import {
  Col,
  Container,
  Row,
  Tooltip,
  Button,
  Icon,
  Tabs as ArchTabs,
  Accordion,
  AccordionRow,
  Table as PayPalTable,
  Toast,
  Badge,
  Banner,
  Alert,
  HeadingText,
} from '@paypalcorp/pp-react'
import ContentAccordion from '../../../../utils/ContentAccordion'
import TableACDCLimitedRelease from './TableACDCLimitedRelease'
import './accordion.css'

const TableACDCLimitedReleaseAccordion = () => {
  return (
    <div>
      <ContentAccordion>
        <AccordionRow
          heading="ACDC card currency table"
          className="accordion-height-acdc"
        >
          <TableACDCLimitedRelease />
        </AccordionRow>
      </ContentAccordion>
    </div>
  )
}

export default TableACDCLimitedReleaseAccordion
